import { render, staticRenderFns } from "./gradeManagement-gradeItem.vue?vue&type=template&id=0461d0d6&scoped=true"
import script from "./gradeManagement-gradeItem.vue?vue&type=script&lang=js"
export * from "./gradeManagement-gradeItem.vue?vue&type=script&lang=js"
import style0 from "./gradeManagement-gradeItem.vue?vue&type=style&index=0&id=0461d0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461d0d6",
  null
  
)

export default component.exports